<template>
    <div class="bank_title">
        <div class="bank_content">
            <div class="title_l">
                <div class="goback">
                    <img v-if="data.isShow" src="../assets/goback.png" alt="">
                    <span></span>
                </div>
                <div class="model">
           
                </div>
            </div>
            <!-- <span class="title_name">{{ data.name }}</span> -->
            <span class="title_name">文山州运营指挥中心</span>
            <div class="title_r">
                <div class="model">

                </div>
                <div class="time">
                    <span @click="exitLogin">退出</span>
                    <!-- <label>{{time}}</label> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { parseTime } from '@/utils/format.js'
export default {

    data() {
        return {
            time: parseTime(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            userName: '',
            login: ''
     
        };
    },
    props: {
        data: Object
    },
    created() {
    
        this.activeNav = this.$route.meta.activeNav
        this.time = parseTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
        setInterval(() => {
            this.time = parseTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
        }, 1000)
        this.userName = window.localStorage.getItem('NMYDATAAUSERNAME')
        this.login = window.localStorage.getItem('LOGIN')
        // console.log( this.login,'this.login');
    },
    watch: {},
    methods: {
        exitLogin() {
            this.$router.push({ path: '/wenlogin' })
            window.localStorage.removeItem('mapfileUrl')
            window.localStorage.removeItem('NMYDATAUSERINFO')
            window.localStorage.removeItem('NMYDATAASSTSTOKEN')
            window.localStorage.removeItem('LOGIN')
            // this.$router.push({ path: '/login' })
        },
        goback() {
            this.$router.go(-1)
        },
     

    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        background: #020e2a;

        .bank_content {
            height: 1rem;
            // background-image: url("../assets/data_title_bg.png");
            background-size: 100% 100%;
            display: flex;
            justify-content: space-between;
            // align-items: center;

            .title_name {
                display: block;
                flex: 1;
                // height: 1rem;
                // padding-bottom: 0.24rem;
                line-height: .9rem;
                text-align: center;
                background-image: url("../assets/middle.png");
                background-size: 100% 100%;
                font-size: 0.45rem;
                font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
                font-weight: 500;
                color: #FFFFFF;
                letter-spacing: 3px;
            }

            .title_l,
            .title_r {
                height: 0.78rem;
                width: 7.75rem;
                display: flex;
                justify-content: space-between;
                padding-bottom: 0.24rem;

                .model {
                    display: flex;
                }

                .model_item {
                    // width: 1.7rem;
                    width: 1.4rem;
                    height: 0.52rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // background-image: url("../assets/btn_bg_1.png");
                    background-image: url("../assets/new_bg_2.png");
                    background-size: 100% 100%;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #A3D8D6;
                    cursor: pointer;
                    margin-top: .1rem;

                }

                .current_nav_l {
                    // background-image: url("../assets/btn_bg_003.png");
                    background-image: url("../assets/new_bg_3.png");
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #032929;
                }

                .current_nav {
                    // background-image: url("../assets/btn_bg_2.png") !important;
                    background-image: url("../assets/new_bg_4.png") !important;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #032929;
                }
            }

            .title_l {
                background-image: url("../assets/left.png");
                background-size: 100% 100%;
                padding-right: .6rem;

                .goback {
                    // margin-top: 0.49rem;
                    display: flex;
                    align-items: center;
                }

                img {
                    width: 0.14rem;
                    height: 0.23rem;
                    margin-right: 0.1rem;
                    cursor: pointer;
                }

                span {
                    font-size: 0.18rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: rgba(0, 224, 219, 0.97);
                }
            }

            .title_r {
                background-image: url("../assets/right.png");
                background-size: 100% 100%;
                padding-left: .6rem;

                .time {
                    display: flex;
                    align-items: center;
                    padding-right: 0.11rem;
                }

                .time label {
                    font-size: 0.1rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: #2C75FD;
                    margin-top: 0.15rem;
                }

                .time span {
                    display: block;
                    font-size: 0.18rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: #FFFFFF;
                    margin-left: -0.75rem;
                    cursor: pointer;
                    margin-top: 0.2rem;
                }

                .model_item {
                    // background-image: url("../assets/btn_bg_004.png");
                    background-image: url("../assets/new_bg_1.png");
                }
            }
        }

        img {
            height: 0.45rem;
        }

    }
}
</style>